<template>
	<div class="border-b border-black-studio-200"></div>
</template>
